// The only file to edit when copying this view into another app.
// Nothing else in this folder refers to the host application.
const coldemailer_config = {

	// Base URL of the host app's backend, which proxies to the cold emailer service
	server_url: 'http://192.168.0.2:8732',

	// Path prefix every endpoint sits under. No service name appears in it, so the service behind
	// these routes can be replaced without touching a single path.
	api_prefix: '/api',

	// Space cleared at the top of the view for a fixed header, or 0 when the host app has none
	top_offset_px: 65,

	// Route the host app mounts the campaign list on. The detail view lives at this path plus /:id
	campaign_route: '/admin/cold-emailer',

	// Route the host app mounts the campaign email editor on. The view lives at this path plus /:id
	campaign_email_route: '/admin/cold-emailer/email',

	// Route the host app mounts the outreach recipient view on. The view lives at this path plus /:id
	outreach_recipient_route: '/admin/cold-emailer/recipient',

	// Route the host app mounts the lead discovery browse view on. The company detail view lives
	// at this path plus /:id
	lead_discovery_route: '/leaddiscovery',

	// Route the host app mounts the email list view on. The view lives at this path plus /:id
	email_list_route: '/admin/cold-emailer/list',

	// Key the lead discovery view stores its filter state under, so a refresh or a trip to another
	// view comes back to the same search. Prefixed with the host app's name, since localStorage is
	// shared across everything served from the same origin.
	lead_discovery_filters_key: 'aicalltrainer-leaddiscovery-filters',

	// Auth token for the host app's own API, or null when it does not use one
	get_auth_token: () => {
		return localStorage.getItem('aicalltrainer-token');
	},

	// Identifier the host app's route guard expects, or null when it does not need one
	get_user_id: () => {
		return localStorage.getItem('aicalltrainer-user-id');
	}
};

export default coldemailer_config;
